/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Typo } from 'uikit/content';

import SearchResultListItem from './searchResultListItem';
import TreeItemSelectorModalContent from './treeItemSelectorModalContent';

import treeItemSelectorModalStyles from '../styles/treeItemSelectorModal.module.scss';
import styles from '../styles/treeItemSelectorModalSearchResults.module.scss';

const TreeItemSelectorModalSearchResults = ({
  destination = null,
  isShowingNoSearchResults = true,
  isShowingSearch = true,
  noSearchResultsText,
  onItemClick,
  source,
  treeItemSelectorModalSearchResults,
}) => (
  <div className={styles.element}>
    {isShowingSearch && (
      <ul className={styles.searchResults}>
        {treeItemSelectorModalSearchResults.map((searchResult) => {
          const isSourceInAncestry = (searchResult.ancestry || []).findIndex((ancestor) => ancestor.id === source.id) !== -1;

          const item = {
            id: searchResult.id,
            data: {
              ...searchResult,
              title: searchResult.name,
              isSource: searchResult.id === source?.id,
              isDestination: searchResult.id === destination?.id,
              sourceId: source?.id,
              isSourceInAncestry,
            },
            onItemClick,
          };

          return (
            <SearchResultListItem
              key={item.id}
              listItemClassName={classNames(treeItemSelectorModalStyles.listItem, {
                [treeItemSelectorModalStyles.isSelected]: item.id === destination?.id,
                [treeItemSelectorModalStyles.isDisabled]: item.id === source?.id || isSourceInAncestry,
              })}
              item={item}
              components={{
                Content: TreeItemSelectorModalContent,
              }}
            />
          );
        })}
      </ul>
    )}
    {isShowingNoSearchResults && (
      <Typo className={styles.noResults}>
        {noSearchResultsText}
      </Typo>
    )}
  </div>
);

TreeItemSelectorModalSearchResults.propTypes = {
  destination: PropTypes.shape({ id: PropTypes.number }),
  isShowingSearch: PropTypes.bool,
  isShowingNoSearchResults: PropTypes.bool,
  treeItemSelectorModalSearchResults: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    ancestry: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })),
  })).isRequired,
  noSearchResultsText: PropTypes.string.isRequired,
  onItemClick: PropTypes.func.isRequired,
  source: PropTypes.shape({ id: PropTypes.number }).isRequired,
};

export default React.memo(TreeItemSelectorModalSearchResults);
